    /**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
$(function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/4d2a735539501671dde69dba5b882d15.webp",
    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/93c88195eec5733aa9050dddc6884831.webp",
    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/6605d0e384f5ba64017cddb7eb83024f.jpg",
    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/70f4d7f87927ea5627078985fe47733a.webp",
    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/74fab01102793104e822a4967eab8f50.png",
    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/63183817df092f162c05df6409636231.webp",

    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/adc4a564dcc0e504dbf1482fb40b311f.webp",
    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/84eb595a753eee11b78f34d5d898a5e6.webp",
    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/ea52e57ac5239f822289fd9a323ebd0b.webp",
    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/e70b6cabfa0d82d238d6a3e8be7e1d2f.webp",
    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/2b31499578fa750c6ce77f81ff9175db.webp",
    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/8ce5ae1d374cce3e2f1404b24d092743.webp",
    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/9782900e4ae7815203d4a0de6688a598.webp",

    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/176204ed9ea3cc7ae1f1eb5e411e35b1.webp",
    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/079fa4148b579cbc0ec2e227c52f7e38.webp",
    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/15ad0aadeb3052d1ae4872b414ced33c.webp",
    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/9a770df0a927332b35e37e30947b6c0c.webp",
    "https://cdn.shopify.com/s/files/1/0618/9046/1902/files/2b158bff1594b276d2ed0609172b578c.webp",
  ];

  // new Swiper("#sp-swiper2", {
  //   autoplay: true,
  //   autoplay: {
  //     disableOnInteraction: false,
  //   },
  //   spaceBetween: 0,
  //   slidesPerView: "auto",
  //   centeredSlides: true,
  //   loop: true,
  //   pagination: {
  //     el: ".sp-pagination1",
  //     clickable: true,
  //   },
  // });

  let spswiper0 = new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    on: {
      slideChange: function (e) {
        $("#swiper-btns .sp-swiper-option")
          .eq(e.realIndex)
          .addClass("active")
          .siblings()
          .removeClass("active");
      },
    },
    navigation: {
      nextEl: ".swiper-btn-next",
      prevEl: ".swiper-btn-prev",
    },
    loop: true,
  });

  // 点击切换轮播
  $("#swiper-btns .sp-swiper-option").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    spswiper0.slideToLoop($(this).index());
  });
  function mainRender() {
    console.log(1111111111)
    $(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() + $(".sp-header-top").height() - 10;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  let sp_price1 = 29.99;
  let sp_price2 = 49.99;

  // function calcTotal(price, num) {
  //   let _result = Number(price) * Number(num);

  //   return _result.toFixed(2);
  // }

    let prods = window.product
    console.log(prods,'prods')
  function getCur(that){
        let productid = $(that).closest('.sp-bottom').find('.sp-btn-style').attr('data-id')
        // console.log(productid,"id")
//注意父盒子是否正确
        return prods.filter(item=> item.id == productid)[0]
      }
      
  function calcTotal(that) {
    let num = $(that).closest('.sp-bottom').find('#calcNumber').val()
    let price = (getCur(that).price * num / 100)
    let compare = (getCur(that).compare_at_price * num / 100)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
  const $productBox = $(that).closest('.sp-bottom').prev('.product-box');

    $productBox.find('.sp-price1').html(price + " Kč");
    $productBox.find('.sp-price2').html(compare + " Kč");
    // $(that).closest('.product-part').find(".sp-price1").html(price);
    // console.log($productBox,"111")
    // $(that).closest('.product-part').find(".sp-price2").html(compare);
  }

  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    let that = this
    calcTotal(that)
    // $("#sp_price1").html(calcTotal(sp_price1, input.value));
    // $("#sp_price2").html(calcTotal(sp_price2, input.value));
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    let that = this
    calcTotal(that)
    // $("#sp_price1").html(calcTotal(sp_price1, input.value));
    // $("#sp_price2").html(calcTotal(sp_price2, input.value));
  });
  $('.sp-btn-style').click(function(){
    let id = $(this).parents(".sp-bottom").find(".sp-btn-style").attr('data-id')
    let num = $(this).siblings('.addGroup').find('input').val()
    console.log(id,num)
    num == undefined ? num = 1 : ''
console.log(id,'-----')
//     let id = $(this).attr('data-id')
    window.location.href = '/cart/' + id + ':' + num
// $.post('/api/checkout/order', {
//   line_items: [{
//     quantity: num, // 数量
//     variant_id: id, // 子商品id
//     note: '', // 备注
//   }],
//   refer_info: { source: 'buy_now' }
// }, function (ret) {
//   if (ret.state === 'success') {
//     return (window.safeHref = '/checkout/' + ret.data.order_token + '?step=contact_information');
//   } else {
//     $.toast.show({
//       content:
//         {
//           '30003': "Some items have been removed, please re-order",
//           'line_items_variant_withdraw': "Some items have been sold out, please re-order",
//           'line_items_variant_sold_out': "Some items are not in stock, please re-order"
//         }[ret.state] || ret.errors[0] || "Some items information has been updated, please re-order"
//     });
//   }
// });

  })
  $(".product-box .sp-opt").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    let _index = $(this).index();

    $(this)
      .parents(".product-box")
      .find(".sp-p-img")
      .eq([_index])
      .show()
      .siblings(".sp-p-img")
      .hide();
  });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

})